import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = ["href", "title"]
const _hoisted_3 = { class: "_flex _gap-1 gfu-bt--caption _tc--light" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_backer_center_thumbnail = _resolveComponent("backer-center-thumbnail")
  const _component_base_text = _resolveComponent("base-text")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_notification_delivery_time = _resolveComponent("notification-delivery-time")
  const _component_backer_center_header = _resolveComponent("backer-center-header")

  return (_openBlock(), _createElementBlock("div", {
    class: "_flexcol _px-2 _py-3",
    "data-qa": `updates-feed-card:${$props.projectUpdateID}`
  }, [
    _createElementVNode("a", {
      href: $props.projectUrl,
      class: "gfu-bt--caption _tc--light _mb-2",
      title: $props.projectName,
      "data-qa": "project-name-link"
    }, _toDisplayString($props.projectName), 9 /* TEXT, PROPS */, _hoisted_2),
    _createVNode(_component_backer_center_header, null, _createSlots({
      default: _withCtx(() => [
        _createVNode(_component_base_text, {
          as: "a",
          href: $props.projectUpdateUrl,
          level: "b1",
          class: "_tc--dark _line-clamp-2",
          title: $props.title
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.title), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href", "title"]),
        ($options.hasAbstract)
          ? (_openBlock(), _createBlock(_component_base_text, {
              key: 0,
              as: "div",
              level: "caption",
              class: "_my-1 _tc--base"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.abstract), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createVNode(_component_base_icon, { name: "thumbs-up" }),
            _createElementVNode("span", null, _toDisplayString($props.likesCount), 1 /* TEXT */)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("span", null, "•", -1 /* CACHED */)),
          _createVNode(_component_notification_delivery_time, { timestamp: $props.publishedAt }, null, 8 /* PROPS */, ["timestamp"])
        ])
      ]),
      _: 2 /* DYNAMIC */
    }, [
      ($options.effectiveImageUrl)
        ? {
            name: "prefix",
            fn: _withCtx(() => [
              _createVNode(_component_backer_center_thumbnail, {
                "image-url": $options.effectiveImageUrl,
                name: $props.projectName,
                size: $options.avatarSize,
                url: $props.projectUpdateUrl
              }, null, 8 /* PROPS */, ["image-url", "name", "size", "url"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1024 /* DYNAMIC_SLOTS */)
  ], 8 /* PROPS */, _hoisted_1))
}